<template>
  <div id="testimonialThree"></div>
</template>

<script>
export default {
  name: "TestimonialThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote:
          "This product completely transformed how we work. The results speak for themselves.",
        name: "Sarah Johnson",
        role: "Head of Marketing",
        company: "TechCorp Inc.",
        rating: 5,
        chip: "Customer Story",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("testimonialThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const quoteSize = exporting ? 46 : 46 * this.scale;
      const nameSize = exporting ? 28 : 28 * this.scale;
      const roleSize = exporting ? 22 : 22 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const quoteMarkSize = exporting ? 300 : 300 * this.scale;
      const starSize = exporting ? 24 : 24 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      const rating = this.data.rating || 5;
      const starsHtml = Array(5)
        .fill(0)
        .map(
          (_, i) => `
        <span style="color: ${i < rating ? "#fbbf24" : "#d1d5db"}; font-size: ${starSize}px;">★</span>
      `,
        )
        .join("");

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Giant decorative quote mark -->
          <div style="
            position: absolute;
            top: -40px;
            right: 40px;
            font-size: ${quoteMarkSize}px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 900;
            color: #000000;
            opacity: 0.06;
            line-height: 1;
            pointer-events: none;
            user-select: none;
          ">"</div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Testimonial content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="margin-bottom: 24px;">${starsHtml}</div>
            
            <div style="
              font-size: ${quoteSize}px;
              font-family: 'Playfair Display', 'Georgia', serif;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 1.4;
              margin-bottom: 40px;
              max-width: 90%;
            ">"${this.data.quote}"</div>

            <div style="margin-bottom: 32px;">
              <p style="
                color: #1a1a1a;
                font-size: ${nameSize}px;
                margin: 0;
                font-weight: 700;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
                display: inline-block;
                position: relative;
              ">
                ${this.data.name}
                <span style="
                  position: absolute;
                  bottom: -8px;
                  left: 0;
                  width: 100%;
                  height: 4px;
                  background: ${primaryColor};
                "></span>
              </p>
              <p style="
                color: #666666;
                font-size: ${roleSize}px;
                margin: 16px 0 0 0;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
              ">${this.data.role}${this.data.company ? ` at ${this.data.company}` : ""}</p>
            </div>

            <!-- Chip -->
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
